export class TechSupport {
    constructor(
        public id: number,
        public title: string,
        public region: string,
        public phone: string,
        public location: string,
        public email: string
    ) { }
}